<template>
  <div></div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'ProjectBasis',
  data() {
    return {
      slug: null
    }
  },
  computed : {
    projectData() {
      let data = this.$store.getters.getProjectBySlug({
        slug: this.slug
      });
      // console.log(data)
      return data
    },
    title() {
      return this.projectData.name;
    },
    afbeelding() {
      return (this.projectData.image) 
        ? this.projectData.image[0].url
        : false;
    },    
    partijen() {
      let tags = [];
      let items = this.projectData.partijen;
      let vm = this;

      if (items) {
        items.forEach((item) => {
          item = vm.$store.getters.getPartijById({id: item});
          if (item) {
            tags.push(item); 
          }
        });
      }

      return tags
        .filter((v, i, a) => a.indexOf(v) === i) // unique
    },
    themas() {
      let tags = [];
      let items = this.projectData.themas;
      let vm = this;
      if (items) {
        items.forEach((item) => {
          item = vm.$store.getters.getThemaById({id: item});
          if (item) {
            item.type = 'thema';
            tags.push(item); 
          }
        });
      }

      return tags
        .filter((v, i, a) => a.indexOf(v) === i) // unique
    },
    tableData() {

      let tableData = [];
      let data = this.projectData;
      // let vm = this;

      if (data.plaats) {
        tableData.push({
          label: 'Gemeente',
          value: data.plaats // ook Single Select = array
        })
      }
      if (data.indienenrv) {
        tableData.push({
          label: 'Geplande RV indiening',
          value: data.indienenrv
        })
      }

      return tableData;
    }
  },
  created() { 
    this.slug = this.$route.params.slug 
      ? this.$route.params.slug 
      : 'error';

    // Scroll to top on opening...
    VueScrollTo.scrollTo(
      document.querySelector('#header'), 
      500, {
        container: document.querySelector('.MainPanelContainer')
    });

    if (this.slug !== 'error') {
      this.$store.dispatch('setActiveProject', {slug: this.slug})

      if (
        this.$store.map && 
        this.projectData.location &&
        this.projectData.location.lat && 
        this.projectData.location.lng
      ) {
        this.$store.map.flyTo({
          center: [
              parseFloat(this.projectData.location.lng, 10),
              parseFloat(this.projectData.location.lat, 10)
          ],
          zoom: 14
        }); 
      }
    }
  },
  mounted() {
    if (this.$store.map) {
      this.$store.map.setFilter('verhalen', ['has', 'project_'+this.slug]);
      this.$store.map.setFilter('verhalen_muted', ['!has', 'project_'+this.slug]);
    }
  },
  destroyed() {
    if (this.$store.map) {
      this.$store.map.setFilter('verhalen', ['all']);
      this.$store.map.setFilter('verhalen_muted', ['==', 'type', 'off']);
    }
  }
}
</script>

<style>

</style>
